import * as z from "zod";

export const RunExecutionKindSchema = z.enum(["legacy", "conversation", "task"]);
export type RunExecutionKind = z.infer<typeof RunExecutionKindSchema>;
export const DREAMBOT_EXECUTOR_VERSION = 2;
export const RunControlInputSchema = z.object({
  runId: z.string().min(1),
  command: z.enum(["pause", "resume", "cancel"]),
  expectedVersion: z.number().int().nonnegative(),
  clientNonce: z.string().min(1).max(200),
});
export type RunControlInput = z.infer<typeof RunControlInputSchema>;
export const RunProgressSnapshotSchema = z.object({
  runId: z.string(),
  version: z.number().int().nonnegative(),
  cursor: z.number().int().min(-1),
  status: z.string(),
  stage: z.string().nullable(),
  blocker: z.string().nullable(),
  artifactIds: z.array(z.string()),
  updatedAt: z.string().datetime(),
  outcome: z
    .object({
      status: z.enum(["complete", "partial", "blocked"]),
      verifiedCount: z.number().int().nonnegative(),
      unverifiedCount: z.number().int().nonnegative(),
    })
    .nullable()
    .optional(),
});
export const RunTaskSummarySchema = RunProgressSnapshotSchema.extend({
  prompt: z.string(),
  createdAt: z.string().datetime(),
});
export const TaskOutcomeSchema = z.object({
  status: z.enum(["complete", "partial", "blocked"]),
  deliverables: z.array(
    z
      .object({
        artifactId: z.string().optional(),
        externalReference: z.string().optional(),
        verified: z.boolean(),
      })
      .refine((item) => Boolean(item.artifactId || item.externalReference), "Evidence is required"),
  ),
  reason: z.string().max(2000).optional(),
});
export type TaskOutcome = z.infer<typeof TaskOutcomeSchema>;
export const TaskOutcomeInputSchema = z
  .object({
    status: z.enum(["complete", "partial", "blocked"]),
    artifactIds: z.array(z.string().min(1)).max(20),
    externalReferences: z.array(z.string().max(1000)).max(20).default([]),
    reason: z.string().max(2000).optional(),
  })
  .strict();
